const normalizeKey = value => String(value || '').trim().toLowerCase();

const humanize = value => {
  const normalized = normalizeKey(value);
  if (!normalized) return '';
  return normalized
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .replace(/^./, char => char.toUpperCase());
};

const ES_LABELS = {
  common: {
    unknown: 'Sin especificar',
    not_available: 'No disponible',
    none: 'Sin datos'
  },
  order: {
    paid: 'Pagada',
    confirmed: 'Confirmada',
    payment_required: 'Pago pendiente',
    payment_in_process: 'Pago en proceso',
    partially_paid: 'Pago parcial',
    cancelled: 'Cancelada',
    cancelled_by_user: 'Cancelada por el usuario',
    invalid: 'Inválida',
    refunded: 'Reintegrada',
    charged_back: 'Contracargo'
  },
  payment: {
    approved: 'Aprobado',
    paid: 'Pagado',
    pending: 'Pendiente',
    in_process: 'En proceso',
    in_mediation: 'En mediación',
    rejected: 'Rechazado',
    cancelled: 'Cancelado',
    refunded: 'Reintegrado',
    charged_back: 'Contracargo',
    authorized: 'Autorizado',
    accredited: 'Acreditado'
  },
  payment_detail: {
    accredited: 'Acreditado',
    pending_waiting_payment: 'Esperando pago',
    pending_review_manual: 'En revisión manual',
    pending_contingency: 'Pendiente por contingencia',
    pending_bank_transfer: 'Esperando transferencia',
    cc_rejected_bad_filled_card_number: 'Tarjeta inválida',
    cc_rejected_bad_filled_date: 'Vencimiento inválido',
    cc_rejected_bad_filled_security_code: 'Código de seguridad inválido',
    cc_rejected_blacklist: 'Pago rechazado',
    cc_rejected_call_for_authorize: 'Requiere autorización',
    cc_rejected_card_disabled: 'Tarjeta deshabilitada',
    cc_rejected_card_error: 'Error de tarjeta',
    cc_rejected_duplicated_payment: 'Pago duplicado',
    cc_rejected_high_risk: 'Rechazado por riesgo',
    cc_rejected_insufficient_amount: 'Fondos insuficientes',
    cc_rejected_invalid_installments: 'Cuotas inválidas',
    cc_rejected_max_attempts: 'Máximo de intentos alcanzado',
    cc_rejected_other_reason: 'Pago rechazado',
    refunded: 'Reintegrado',
    bpp_refunded: 'Reintegrado por Compra Protegida',
    charged_back: 'Contracargo',
    by_admin: 'Cancelado por administración',
    by_collector: 'Cancelado por el vendedor',
    by_payer: 'Cancelado por el comprador'
  },
  shipping: {
    pending: 'Pendiente',
    handling: 'En preparación',
    ready_to_ship: 'Listo para enviar',
    shipped: 'En camino',
    delivered: 'Entregado',
    not_delivered: 'No entregado',
    cancelled: 'Cancelado',
    closed: 'Cerrado',
    error: 'Con error',
    returned: 'Devuelto',
    lost: 'Extraviado',
    damaged: 'Dañado',
    delayed: 'Demorado',
    receiver_absent: 'Comprador ausente',
    soon_deliver: 'Por entregar',
    waiting_for_withdrawal: 'Esperando retiro',
    dropped_off: 'Despachado',
    picked_up: 'Retirado',
    in_hub: 'En centro logístico',
    on_route_to_pickup: 'En camino a retiro',
    waiting_for_label_generation: 'Esperando etiqueta'
  },
  shipping_mode: {
    me1: 'Mercado Envíos 1',
    me2: 'Mercado Envíos 2',
    custom: 'Envío personalizado',
    not_specified: 'Sin especificar'
  },
  logistic: {
    drop_off: 'Mercado Envíos',
    xd_drop_off: 'Punto de despacho ML',
    cross_docking: 'Mercado Envíos Colecta',
    self_service: 'Mercado Envíos Flex',
    fulfillment: 'Mercado Envíos Full',
    full: 'Mercado Envíos Full',
    flex: 'Mercado Envíos Flex',
    turbo: 'Mercado Envíos Turbo',
    custom: 'Logística propia',
    default: 'Mercado Envíos',
    not_specified: 'Sin especificar'
  },
  publication: {
    active: 'Activa',
    paused: 'Pausada',
    closed: 'Finalizada',
    inactive: 'Inactiva',
    under_review: 'En revisión',
    payment_required: 'Pago requerido',
    forbidden: 'Restringida'
  },
  payment_type: {
    credit_card: 'Tarjeta de crédito',
    debit_card: 'Tarjeta de débito',
    account_money: 'Dinero en cuenta',
    bank_transfer: 'Transferencia bancaria',
    ticket: 'Cupón de pago',
    atm: 'Cajero',
    digital_currency: 'Moneda digital'
  }
};

const EN_LABELS = {
  common: {
    unknown: 'Unspecified',
    not_available: 'Not available',
    none: 'No data'
  },
  order: {
    paid: 'Paid',
    confirmed: 'Confirmed',
    payment_required: 'Payment pending',
    payment_in_process: 'Payment in process',
    partially_paid: 'Partially paid',
    cancelled: 'Cancelled',
    cancelled_by_user: 'Cancelled by user',
    invalid: 'Invalid',
    refunded: 'Refunded',
    charged_back: 'Chargeback'
  },
  payment: {
    approved: 'Approved',
    paid: 'Paid',
    pending: 'Pending',
    in_process: 'In process',
    in_mediation: 'In mediation',
    rejected: 'Rejected',
    cancelled: 'Cancelled',
    refunded: 'Refunded',
    charged_back: 'Chargeback',
    authorized: 'Authorized',
    accredited: 'Accredited'
  },
  payment_detail: {
    accredited: 'Accredited',
    pending_waiting_payment: 'Waiting for payment',
    pending_review_manual: 'Manual review',
    pending_contingency: 'Pending contingency',
    pending_bank_transfer: 'Waiting for transfer',
    refunded: 'Refunded',
    bpp_refunded: 'Buyer Protection refund',
    charged_back: 'Chargeback'
  },
  shipping: {
    pending: 'Pending',
    handling: 'In preparation',
    ready_to_ship: 'Ready to ship',
    shipped: 'Shipped',
    delivered: 'Delivered',
    not_delivered: 'Not delivered',
    cancelled: 'Cancelled',
    closed: 'Closed',
    returned: 'Returned',
    lost: 'Lost',
    damaged: 'Damaged',
    delayed: 'Delayed',
    receiver_absent: 'Buyer absent',
    soon_deliver: 'Out for delivery',
    waiting_for_withdrawal: 'Waiting for pickup',
    dropped_off: 'Dropped off',
    picked_up: 'Picked up',
    in_hub: 'At logistics hub'
  },
  shipping_mode: {
    me1: 'Mercado Envios 1',
    me2: 'Mercado Envios 2',
    custom: 'Custom shipping',
    not_specified: 'Unspecified'
  },
  logistic: {
    drop_off: 'Mercado Envios',
    xd_drop_off: 'Punto de despacho ML',
    cross_docking: 'Mercado Envios Pickup',
    self_service: 'Mercado Envios Flex',
    fulfillment: 'Mercado Envios Full',
    full: 'Mercado Envios Full',
    flex: 'Mercado Envios Flex',
    turbo: 'Mercado Envios Turbo',
    custom: 'Custom logistics',
    default: 'Mercado Envios',
    not_specified: 'Unspecified'
  },
  publication: {
    active: 'Active',
    paused: 'Paused',
    closed: 'Closed',
    inactive: 'Inactive',
    under_review: 'Under review',
    payment_required: 'Payment required',
    forbidden: 'Restricted'
  },
  payment_type: {
    credit_card: 'Credit card',
    debit_card: 'Debit card',
    account_money: 'Account money',
    bank_transfer: 'Bank transfer',
    ticket: 'Payment coupon',
    atm: 'ATM',
    digital_currency: 'Digital currency'
  }
};

const LABELS_BY_LANGUAGE = {
  es: ES_LABELS,
  en: EN_LABELS
};

const getLanguageKey = language => (
  String(language || 'es').toLowerCase().startsWith('en') ? 'en' : 'es'
);

export const getMercadoLibreLabel = (category, value, language = 'es', fallback = undefined) => {
  const normalized = normalizeKey(value);
  if (!normalized) {
    return fallback !== undefined ? fallback : LABELS_BY_LANGUAGE[getLanguageKey(language)].common.not_available;
  }
  const labels = LABELS_BY_LANGUAGE[getLanguageKey(language)] || ES_LABELS;
  return labels[category]?.[normalized] || labels.common?.[normalized] || humanize(value) || fallback || '';
};

export const formatMercadoLibreList = (items, category, language = 'es') =>
  (items || [])
    .map(item => getMercadoLibreLabel(category, item, language))
    .filter(Boolean)
    .join(' · ');
